import './styles.scss';

export const Warning = ({ label = '' }) => {
  return <div className="warning_container">
    <div className="icon__container">
      <i className="fi fi-sr-exclamation" />
    </div>
    <div className="main_text">
      <span>{label}</span>
    </div>
  </div>
}